import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import XButton from './XButton';

export default function DialogBox({ description, open, handleSubmit, handleClose }) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  return (
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        slotProps={{ paper: { sx: { backgroundColor: 'var(--color-surface)' } } }}
      >
        <DialogContent>
          <DialogContentText>
          {description}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <XButton variant="outline" onClick={handleClose}>
            No
          </XButton>
          <XButton variant="primary" onClick={handleSubmit} autoFocus>
            Yes
          </XButton>
        </DialogActions>
      </Dialog>
  );
}
